/**
 * Фон карточки профиля — магазинный SKU.
 */

import { CosmeticsHarmony } from "./profileCosmeticsHarmony"

export type ProfileCardBgKey =
  | "ember_core"
  | "tide_deep"
  | "storm_void"
  | "aurora_field"
  | "mist_soft"
  | "magma_dark"
  | "forest_moss"
  | "ice_sheet"
  | "dusk_violet"
  | "clean_steel"
  | "sunset_gold"
  | "blood_wine"
  | "ocean_abyss"
  | "jade_temple"
  | "lilac_dream"
  | "amber_sand"
  | "neon_night"
  | "pearl_frost"

export interface ProfileCardBgStyle {
  gradient: readonly [string, string, string] | null
  overlayColor: string
  winrateColor: string
  rowBackground: string
  harmony: CosmeticsHarmony
}

export interface ProfileCardBgDef {
  key: ProfileCardBgKey
  title: string
  subtitle: string
  style: ProfileCardBgStyle
}

export const PROFILE_CARD_BACKGROUNDS: ProfileCardBgDef[] = [
  {
    key: "ember_core",
    title: "Угольное ядро",
    subtitle: "Красно-оранжевый жар",
    style: {
      gradient: ["#1C0A0A", "#7F1D1D", "#EA580C"],
      overlayColor: "rgba(251,146,60,0.08)",
      winrateColor: "#FDBA74",
      rowBackground: "rgba(127,29,29,0.35)",
      harmony: "ember",
    },
  },
  {
    key: "tide_deep",
    title: "Глубинный прилив",
    subtitle: "Тёмная бирюза",
    style: {
      gradient: ["#042F2E", "#0E7490", "#155E75"],
      overlayColor: "rgba(45,212,191,0.07)",
      winrateColor: "#67E8F9",
      rowBackground: "rgba(15,118,110,0.35)",
      harmony: "tide",
    },
  },
  {
    key: "storm_void",
    title: "Штормовая пустота",
    subtitle: "Сине-фиолетовая гроза",
    style: {
      gradient: ["#020617", "#1E3A8A", "#7C3AED"],
      overlayColor: "rgba(167,139,250,0.08)",
      winrateColor: "#A5B4FC",
      rowBackground: "rgba(49,46,129,0.4)",
      harmony: "storm",
    },
  },
  {
    key: "aurora_field",
    title: "Поле сияния",
    subtitle: "Бирюза → фиолет",
    style: {
      gradient: ["#022C22", "#0F766E", "#6D28D9"],
      overlayColor: "rgba(167,139,250,0.1)",
      winrateColor: "#6EE7B7",
      rowBackground: "rgba(76,29,149,0.28)",
      harmony: "aurora",
    },
  },
  {
    key: "mist_soft",
    title: "Мягкая дымка",
    subtitle: "Градиент стихии + вуаль",
    style: {
      gradient: null,
      overlayColor: "rgba(248,250,252,0.14)",
      winrateColor: "#E2E8F0",
      rowBackground: "rgba(148,163,184,0.18)",
      harmony: "mist",
    },
  },
  {
    key: "magma_dark",
    title: "Тёмная магма",
    subtitle: "Уголь с багровым",
    style: {
      gradient: ["#0A0A0A", "#1C1917", "#450A0A"],
      overlayColor: "rgba(239,68,68,0.08)",
      winrateColor: "#F87171",
      rowBackground: "rgba(69,10,10,0.4)",
      harmony: "magma",
    },
  },
  {
    key: "forest_moss",
    title: "Лесной мох",
    subtitle: "Зелёные глубины",
    style: {
      gradient: ["#052E16", "#166534", "#3F6212"],
      overlayColor: "rgba(134,239,172,0.08)",
      winrateColor: "#86EFAC",
      rowBackground: "rgba(20,83,45,0.4)",
      harmony: "forest",
    },
  },
  {
    key: "ice_sheet",
    title: "Ледяной щит",
    subtitle: "Голубой кристалл",
    style: {
      gradient: ["#0C4A6E", "#0369A1", "#E0F2FE"],
      overlayColor: "rgba(186,230,253,0.12)",
      winrateColor: "#BAE6FD",
      rowBackground: "rgba(12,74,110,0.4)",
      harmony: "ice",
    },
  },
  {
    key: "dusk_violet",
    title: "Сумеречный",
    subtitle: "Розово-фиолетовый закат",
    style: {
      gradient: ["#1E1B4B", "#6B21A8", "#DB2777"],
      overlayColor: "rgba(244,114,182,0.1)",
      winrateColor: "#F9A8D4",
      rowBackground: "rgba(88,28,135,0.35)",
      harmony: "dusk",
    },
  },
  {
    key: "clean_steel",
    title: "Чистая сталь",
    subtitle: "Холодный графит",
    style: {
      gradient: ["#0F172A", "#1E293B", "#334155"],
      overlayColor: "rgba(148,163,184,0.08)",
      winrateColor: "#CBD5E1",
      rowBackground: "rgba(51,65,85,0.4)",
      harmony: "steel",
    },
  },
  {
    key: "sunset_gold",
    title: "Закатное золото",
    subtitle: "Янтарь → персик",
    style: {
      gradient: ["#431407", "#B45309", "#FBBF24"],
      overlayColor: "rgba(251,191,36,0.1)",
      winrateColor: "#FDE68A",
      rowBackground: "rgba(146,64,14,0.35)",
      harmony: "ember",
    },
  },
  {
    key: "blood_wine",
    title: "Кровавое вино",
    subtitle: "Бордо → алый",
    style: {
      gradient: ["#1A0508", "#7F1D1D", "#BE123C"],
      overlayColor: "rgba(251,113,133,0.08)",
      winrateColor: "#FDA4AF",
      rowBackground: "rgba(136,19,55,0.4)",
      harmony: "magma",
    },
  },
  {
    key: "ocean_abyss",
    title: "Океанская бездна",
    subtitle: "Индиго → циан",
    style: {
      gradient: ["#020617", "#1E3A8A", "#06B6D4"],
      overlayColor: "rgba(34,211,238,0.08)",
      winrateColor: "#67E8F9",
      rowBackground: "rgba(30,58,138,0.4)",
      harmony: "tide",
    },
  },
  {
    key: "jade_temple",
    title: "Нефритовый храм",
    subtitle: "Изумруд → мята",
    style: {
      gradient: ["#022C22", "#047857", "#6EE7B7"],
      overlayColor: "rgba(110,231,183,0.1)",
      winrateColor: "#A7F3D0",
      rowBackground: "rgba(6,95,70,0.4)",
      harmony: "forest",
    },
  },
  {
    key: "lilac_dream",
    title: "Сиреневый сон",
    subtitle: "Лаванда → роза",
    style: {
      gradient: ["#2E1065", "#7C3AED", "#F0ABFC"],
      overlayColor: "rgba(240,171,252,0.1)",
      winrateColor: "#E9D5FF",
      rowBackground: "rgba(91,33,182,0.35)",
      harmony: "dusk",
    },
  },
  {
    key: "amber_sand",
    title: "Янтарные пески",
    subtitle: "Песок → охра",
    style: {
      gradient: ["#292524", "#A16207", "#FCD34D"],
      overlayColor: "rgba(252,211,77,0.1)",
      winrateColor: "#FDE68A",
      rowBackground: "rgba(120,53,15,0.35)",
      harmony: "ember",
    },
  },
  {
    key: "neon_night",
    title: "Неоновая ночь",
    subtitle: "Чёрный → электрик",
    style: {
      gradient: ["#020617", "#312E81", "#22D3EE"],
      overlayColor: "rgba(34,211,238,0.1)",
      winrateColor: "#A5F3FC",
      rowBackground: "rgba(49,46,129,0.4)",
      harmony: "storm",
    },
  },
  {
    key: "pearl_frost",
    title: "Жемчужный иней",
    subtitle: "Серебро → лёд",
    style: {
      gradient: ["#1E293B", "#64748B", "#F1F5F9"],
      overlayColor: "rgba(241,245,249,0.12)",
      winrateColor: "#E2E8F0",
      rowBackground: "rgba(51,65,85,0.4)",
      harmony: "ice",
    },
  },
]

export const PROFILE_CARD_BG_BY_KEY: Record<ProfileCardBgKey, ProfileCardBgDef> =
  PROFILE_CARD_BACKGROUNDS.reduce(
    (acc, item) => {
      acc[item.key] = item
      return acc
    },
    {} as Record<ProfileCardBgKey, ProfileCardBgDef>
  )

export function isProfileCardBgKey(value: string): value is ProfileCardBgKey {
  return value in PROFILE_CARD_BG_BY_KEY
}

export function resolveProfileCardBg(
  key: string | null | undefined
): ProfileCardBgDef | null {
  if (!key || !isProfileCardBgKey(key)) return null
  return PROFILE_CARD_BG_BY_KEY[key]
}
